import React, { useContext, useState } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";
import session from "../../../stores/session";

export default function useWholesaler() {
    const { apiPrefix } = useContext(ProductContext)
    const [wholesalers, setWholesalers] = useState([]);
    const [selectedWholesaler, setSelectedWholesaler] = useState('');

    const getWholesalers = () => {
        request(true).get('/wholesaler').then(r => {
            setWholesalers(r.data.map(wholesaler => {
                return {
                    label: wholesaler.Label,
                    value: wholesaler.Name
                }
            }));
        }).catch(e => {
            console.log(e);
            window.alert('An error occurred while fetching wholesalers.');
        })
    }

    return { getWholesalers, wholesalers, selectedWholesaler, setSelectedWholesaler }
}